'use client'

/**
 * PostHog Client Identity
 *
 * Client-side PostHog identify wrapper.
 *
 * Primary responsibilities:
 * - Identify authenticated users from browser auth results
 * - Share the same identity payload as the app-shell fallback
 *
 * Dependencies:
 * - posthog-js
 * - posthog-identity
 */

import posthog from 'posthog-js'

import {
  buildPostHogIdentityProperties,
  readPostHogIdentityUserId,
  type PostHogIdentityInput
} from '@/lib/analytics/posthog-identity'

// --------------

export function identifyPostHogUser(input: PostHogIdentityInput) {
  const userId = readPostHogIdentityUserId(input)
  if (!userId) {
    return
  }

  posthog.identify(userId, buildPostHogIdentityProperties(input))
}
